import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import "../styles/header.css";
import { UserContext } from "../pages/UserContext.js"; 

const Header = ({ toggleSidebar }) => {
  const { logout } = useContext(UserContext); 
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(); 
    navigate("/login"); 
  };

  return (
    <header className="dashboard-header">
      {/* Left: Hamburger + Logo */}
      <div className="header-left">
        <button className="menu-btn" onClick={toggleSidebar}>
          <FaBars size={18} />
        </button>
        <span className="logo-name">Guljag</span>
      </div>

      {/* Center: App Name */}
      <div className="header-center">
        <h1>AutoShop</h1>
      </div>

      {/* Right: Logout */}
      <div className="header-right">
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
